import { IViolationResult } from "@vmosolutions/oc-interfaces";
import { Camera } from "../../../SharedGL/Camera";
import { CrewScheduleErrorsGL } from "./CrewScheduleErrorsGL";

const overLapColor = [0.75, 0.5, 0.0, 1.0]; //orange
export class CrewOverLapsGL extends CrewScheduleErrorsGL {
  private overLapData: IViolationResult[] = [];

  public getOverLapData = (): IViolationResult[] => this.overLapData;

  /**
   * @param dayStartMs - start of day in ms
   * @param dayEndMs - end of day in ms
   * @returns true if any overlap violation touches the day
   */
  public hasOnDay(dayStartMs: number, dayEndMs: number): boolean {
    return (
      this.overLapData?.some(
        (v) => v.status === "fail" && !v.noShow && v.period && v.period.end >= dayStartMs && v.period.start <= dayEndMs
      ) ?? false
    );
  }

  public lastModified = 0;

  /**
   * updateOverlapBuffers - Updates the webGL buffers for over laps
   * @param gl - The WebGL rendering context
   * @param overLaps - Array of overlaps to be rendered (just made them to be the same shape as violations)
   * @param rowHeight - the row height of the crew member to draw day violations
   */
  public updateOverLapsBuffers(
    gl: WebGLRenderingContext,
    overLaps: IViolationResult[],
    rowHeight: number,
    lastModified: number
  ): void {
    this.lastModified = lastModified;
    this.overLapData = overLaps;
    super.updateBuffers(gl, overLaps, rowHeight, overLapColor);
  }

  /**
   * draw - draws the overlaps in webGL
   * @param gl - The WebGL rendering context
   * @param camera - the camera to get dimensions of visible window
   * @param yStart - y dimension of crewMember row start
   */
  public draw(gl: WebGLRenderingContext, camera: Camera, yStart: number): void {
    super.draw(gl, camera, yStart, -5);
  }
}
